export const CAMPAIGN_PACKAGE_SELECTION = `
    id
    promotionStatus
    status
    discountType
    type
    discountValue
    displayDiscountPrice
    name
    displayName
    dayOfWeek
    startTime
    endTime
    startDate
    endDate
    subShopCategories {
        code
        name
        id
    }
    shop {
        id
        name
        displayedAddress
        openHour
        closeHour
        rating
        allowBooking
        location
        avatar {
            url
            alt
        }
        shopChain {
            headOffice {
                id
                name
                displayedAddress
            }
            shops {
                id
                name
                displayedAddress
                avatar {
                    url
                    alt
                }
            }
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    service {
        id
        name
        menuPrice
        duration
        description
    }
    campaign {
        name
        startDate
        endDate
        condition
        relatedCampaignPackages {
          docs {
            id
            name
            displayName
            shop {
                id
                name
                displayedAddress
            }
          }
        }
    }
`;
export const CAMPAIGN_PACKAGE_SLOT_SELECTION = `
    id
    promotionStatus
    status
    displayName
    dayOfWeek
    discountType
    discountValue
    displayDiscountPrice
    isDisplay
    name
    startTime
    endTime
    startDate
    endDate
    dayOfWeek
    type
    status
`;
export const CAMPAIGN_PACKAGE_CARD_SELECTION = `
   id
    promotionStatus
    status
    type
    discountType
    discountValue
    displayDiscountPrice
    name
    dayOfWeek
    displayName
    subShopCategories {
        code
        name
        id
    }
    shop {
        id
        name
        displayedAddress
        openHour
        closeHour
        rating
        allowBooking
        location
        avatar {
            url
            alt
        }
        shopChain {
            headOffice {
                id
                name
                displayedAddress
            }
            shops {
                id
                name
                displayedAddress
                avatar {
                    url
                    alt
                }
            }
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    service {
        id
        name
        menuPrice
        duration
        description
    }
`;
